import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../Layout/Loader';
import { Navigate } from 'react-router-dom';
// import ErrorNoAccount from 'components/Error/ErrorNoAccount';
import setAuthCredentials from '../../setAuthCredentials';
import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';
import { withTranslator } from '../../../I18n/withTranslator';
import LoginViaGoogleConnectorApollo from './Connector/Apollo/LoginViaGoogleConnectorApollo';
import AuthLoginByGoogleTokenWrapperComponent from './AuthLoginByGoogleTokenWrapperComponent';

class AuthLoginByGoogleTokenComponent extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errors: [],
    };
  }

  loginViaGoogle = async (loginViaGoogle, userDataOnDemand) => {
    const response = await loginViaGoogle;

    if (response.data.auth.loginViaGoogle.__typename === 'OauthException') {
      if (response.data.auth.loginViaGoogle.code === 401) {
        this.setState((prevState) => ({
          errors: [...prevState.errors, this.props.t('auth/login/user-not-exists')],
        }));
      }
    } else {
      const userToken = response.data.auth.loginViaGoogle.token;
      setAuthCredentials(userToken);
      await userDataOnDemand();
    }

    this.setState({ isLoading: false });
  };

  render() {
    const token = new URL(document.location.href).searchParams.get('code');
    const state = new URL(document.location.href).searchParams.get('state');
    const noAccountPath = '/auth/no-account';

    let returnPath = global.localStorage.getItem('redirectToPathAfterSuccess') || '/';

    if (state === 'stripe_login') {
      returnPath = '/buy';
    }

    if (state === 'cart_login') {
      returnPath = '/cart/save-payment';
    }

    console.log('returnPath', returnPath);

    return (
      <React.Fragment>
        <LoginViaGoogleConnectorApollo>
          {(result) => (
            <UserDataOnDemand>
              {(result2) => (
                <AuthLoginByGoogleTokenWrapperComponent
                  loginViaGoogle={() =>
                    this.loginViaGoogle(result.loginViaGoogle(token), result2.userDataOnDemand)
                  }
                />
              )}
            </UserDataOnDemand>
          )}
        </LoginViaGoogleConnectorApollo>
        {this.state.isLoading ? (
          <div className="full-height">
            <Loader />
          </div>
        ) : null}

        {!this.state.isLoading && !this.state.errors.length ? <Navigate to={returnPath} /> : null}

        {!this.state.isLoading && this.state.errors.length ? <Navigate to={noAccountPath} /> : null}
      </React.Fragment>
    );
  }
}

export default withTranslator(AuthLoginByGoogleTokenComponent);
